module.exports = require("./Faqs");